import { Component, Inject, OnInit } from '@angular/core';
import { AddStoragePlaceDialogComponent } from './add-storage-place-dialog/add-storage-place-dialog.component';
import { EditStoragePlaceDialogComponent } from './edit-storage-place-dialog/edit-storage-place-dialog.component';
import { StoragePlace } from './storage-place';
import { MatDialog } from '@angular/material/dialog';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { TextTableColumn } from '../../components/kiene-table/table-column';
import { TableOption } from '../../components/kiene-table/table-option';
import { StoragePlaceService } from './storage-place.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-storage-place',
    templateUrl: './storage-place.component.html',
    styleUrls: ['./storage-place.component.scss'],
})
export class StoragePlaceComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        private api: KieneTableService,
        private messageService: MessageService,
        private service: StoragePlaceService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Lagerplätze';
        this.tableDescriptor.uniqueIdentifier = 'Lagerplätze';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'lagerplatz/';
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetails = false;

        this.tableDescriptor.columns = this.getTableColumns();
        this.tableDescriptor.options = this.getTableOptions();

        this.tableDescriptor.permissionView = 1011;
        this.tableDescriptor.permissionCreate = 1012;

        this.tableDescriptor.initialSortColumn = 'bezeichnung';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.addVoid = this.openAddStoragePlaceDialog.bind(this);
    }

    getTableColumns() {
        const columns = [];
        columns.push(new TextTableColumn('bezeichnung', 'Name'));
        columns.push(new TextTableColumn('lager', 'Lager'));
        columns.push(new TextTableColumn('wagen', 'Wagen'));
        return columns;
    }

    openAddStoragePlaceDialog() {
        const dialogRef = this.dialog.open(AddStoragePlaceDialogComponent, { width: '33%' });

        dialogRef.afterClosed().subscribe(storagePlace => {
            if (storagePlace) {
                this.service.saveStoragePlace(storagePlace).subscribe(
                    response => {
                        this.messageService.infoMessage(
                            'Lagerplatz ' + response.bezeichnung + ' wurde erfolgreich gespeichert!',
                        );
                        this.api.reload('openAddStoragePlaceDialog');
                    },
                    error => {
                        this.messageService.errorMessage(
                            'Der Lagerplatz ' + storagePlace.bezeichnung + ' konnte nicht angelegt werden. Fehler: ',
                            error,
                        );
                    },
                );
            }
        });
    }

    openEditStoragePlaceDialog(storagePlace: StoragePlace) {
        const dialogRef = this.dialog.open(EditStoragePlaceDialogComponent, {
            width: '33%',
            data: { storagePlace: storagePlace },
        });

        dialogRef.afterClosed().subscribe(sp => {
            if (sp) {
                this.service.updateStoragePlace(sp).subscribe(
                    response => {
                        this.messageService.infoMessage(
                            'Lagerplatz ' + response.bezeichnung + ' wurde erfolgreich gespeichert!',
                        );
                        this.api.reload('openEditStoragePlaceDialog');
                    },
                    error => {
                        this.messageService.errorMessage(
                            'Der Lagerplatz ' + storagePlace.bezeichnung + ' konnte nicht angelegt werden. Fehler: ',
                            error,
                        );
                    },
                );
            }
        });
    }

    private getTableOptions() {
        const options = [];
        options.push(new TableOption(this.openEditStoragePlaceDialog.bind(this), 'bearbeiten', 'edit', 1013));
        return options;
    }
}
